import { WorkflowTrackerKind } from '@/types/schema';

// These workflow tracker kinds are excluded from the workflow tracker context providers because we don't
// care about showing the processing banner or showing them in the activities sidebar.
export const EXCLUDED_WORKFLOW_TRACKER_KINDS = [
  WorkflowTrackerKind.DocumentChatStream,
  WorkflowTrackerKind.HouseholdChatStream,
];

export const VISIBLE_WORKFLOW_TRACKER_KINDS = Object.values(
  WorkflowTrackerKind
).filter((kind) => !EXCLUDED_WORKFLOW_TRACKER_KINDS.includes(kind));
